import BoxStatistical from '@/components/Statistical/BoxStatistical'
import { getServicesStatistical } from '@/modules/Service/services'
import { formatNumeral, pick } from '@/utils/function'
import { DataGridPayload } from 'vnetwork-ui/dist/components/GokuDataGrid'
import { useQueryWithHandler } from '@/hooks/useQueryWithHandler'
import { QUERY_KEYS } from '@/constants/reactQueryKeys'
import Paper from '@/components/Paper'

interface StatisticalProps {
    params: DataGridPayload
}

const Statistical: React.FC<StatisticalProps> = ({ params }) => {
    const { ...rest } = params
    const { data, renderState, isPending } = useQueryWithHandler({
        queryKey: [
            QUERY_KEYS.SERVICES,
            'statistical',
            JSON.stringify(pick(rest, ['filters', 'q'])),
        ],
        queryFn: () => getServicesStatistical(pick(rest, ['filters', 'q'])),
    })

    const stateComponent = renderState()
    if (stateComponent) return stateComponent

    const dataStatistical = [
        {
            label: 'total-service',
            is_poc: [false],
            service_status: ['active', 'cancelled', 'waiting-create-service'],
        },
        {
            label: 'service-active',
            is_poc: [false],
            service_status: ['active', 'waiting-create-service'],
        },
        {
            label: 'service-cancelled',
            is_poc: [false],
            service_status: ['cancelled'],
        },
        {
            label: 'poc',
            is_poc: [true],
            service_status: ['trialing', 'cancelled'],
        },
    ]

    return (
        <Paper className="grid lg:grid-cols-4 md:grid-cols-2 grid-cols-1 gap-4 p-4">
            {dataStatistical?.map((i) => {
                const totalValue = data?.results
                    ?.filter((item) => {
                        const matchStatus = i.service_status
                            ? i.service_status.includes(item?.service_status)
                            : true
                        const matchRevenue =
                            i.is_poc !== undefined
                                ? (i.is_poc?.includes?.(item?.is_poc) ?? true)
                                : true

                        return matchStatus && matchRevenue
                    })
                    ?.reduce((sum, item) => sum + (item?.count || 0), 0)

                return (
                    <BoxStatistical
                        loading={isPending}
                        label={i?.label}
                        helperText={`${i.label}-description`}
                    >
                        {formatNumeral(totalValue || 0, 0)}
                    </BoxStatistical>
                )
            })}
        </Paper>
    )
}

export default Statistical
